import { connect } from 'react-redux';
import LoginForm from './component';
import { authenticateProfile } from './actions';

const mapStateToProps = state => ({
  user: state.authentication.user
});

const mapDispatchToProps = dispatch => ({
  authenticateProfile: submittedValues => dispatch(authenticateProfile(submittedValues)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login-form/index.js